export const environment = {
  production: true,
  instrumentationKey: "",
  apiUrl: "https://gr-api-stage.azure.chevron.com",
  redirectUri: "https://gr-stage.azure.chevron.com",
  msalClientId: "454f948d-9bac-431e-9698-b48df0526189",
  msalAuthority: "https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  apiScope: "https://whc.azure.chevron.com/user_impersonation",

};
